// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "icomm-2c6d5.firebaseapp.com",
  "projectId": "icomm-2c6d5",
  "storageBucket": "icomm-2c6d5.firebasestorage.app",
  "messagingSenderId": "740814103732",
  "appId": "1:740814103732:web:02e85b6afd4364f6baa3e1",
  "measurementId": "G-9CRNHZBXCK",
  "apiKey": "AIzaSyD6CRhTw6I9uGbdzGDf_9OZkhI0EEjBo_I"
};
